/**
 * Hosen Quick-Win Feature 38 (PDP) — Live Versand-Countdown
 *
 * Custom Element <shipping-countdown>:
 *   data-cutoff-hour      : 0..23
 *   data-cutoff-minute    : 0..59
 *   data-skip-weekend     : "true" | "false"
 *   data-tpl-live         : Template mit {h} {m} {s} (lange Form, vor Cutoff)
 *   data-tpl-live-compact : Template mit {h}:{m}:{s} (kompakte Form, optional)
 *   data-tpl-tomorrow     : Text fuer "morgen"
 *   data-tpl-day-after    : Text fuer "uebermorgen"
 *   data-tpl-weekday      : Template mit {day} fuer beliebige Wochentage
 *   data-day-mon..sun     : Lokalisierte Wochentagsnamen
 *
 * Aktualisiert den enthaltenen [data-text]-Slot einmal pro Sekunde.
 */
(function () {
  if (typeof window === 'undefined' || customElements.get('shipping-countdown')) {
    return;
  }

  class ShippingCountdown extends HTMLElement {
    constructor() {
      super();
      this._timerId = null;
    }

    connectedCallback() {
      this._textEl = this.querySelector('[data-text]');
      if (!this._textEl) return;
      this._render();
      this._timerId = window.setInterval(() => this._render(), 1000);
    }

    disconnectedCallback() {
      if (this._timerId) {
        window.clearInterval(this._timerId);
        this._timerId = null;
      }
    }

    _render() {
      const cutoffMs = parseInt(this.dataset.cutoffTsMs, 10);
      const nextShipLabel = this.dataset.nextShipLabel || '';

      if (Number.isFinite(cutoffMs) && Date.now() < cutoffMs) {
        const diffMs = cutoffMs - Date.now();
        const totalSec = Math.max(0, Math.floor(diffMs / 1000));
        const h = Math.floor(totalSec / 3600);
        const m = Math.floor((totalSec % 3600) / 60);
        const s = totalSec % 60;
        const tpl = this.dataset.tplLive || 'Noch {h}h {m}min {s}s';
        this._textEl.textContent = tpl
          .replace('{h}', String(h))
          .replace('{m}', String(m).padStart(2, '0'))
          .replace('{s}', String(s).padStart(2, '0'));
        this.classList.add('is-live');
        this.classList.remove('is-cutoff');
        return;
      }

      // Post-Cutoff: server-vorgerenderten Text uebernehmen (tz-konsistent zur Karte)
      this._textEl.textContent =
        nextShipLabel || this.dataset.fallbackCutoff || 'Bestellen für Versand morgen';
      this.classList.add('is-cutoff');
      this.classList.remove('is-live');
    }
  }

  customElements.define('shipping-countdown', ShippingCountdown);
})();
